import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Table,
  Pagination,
  SearchBox,
  DropdownList,
  DropdownItem,
  Tooltip,
  Popup,
  Divider,
} from 'next-common-lib';
import { HoverCard, ProfileCard } from 'next-user-lib';
import { useTranslation } from 'react-i18next';
import { WordHighLighter } from './WordHighLighter.js';
import ContactProfileCard from '../ContactProfileCard/ContactProfileCard';
import classes from './TabContact.module.scss';
import './TabContact.scss';
import {
  getGroupList,
  getContactList,
  getMemberGroup,
  searchContactCardAPI,
  searchContactCardPublicAPI,
  searchContactGroupAPI,
  searchGroupAPI,
  getGroupTeamAPI,
  getContactTeamAPI,
  getContactAPI,
  createRecentContact,
  fetchPubContactMenu,
} from '../../apis/contactAPI';

// import { getUserInfoAPI } from '../../apis/userApi';

import {
  FILTER_TEAM,
  FILTER_TYPE,
  FILTER_GROUP,
  DEFAULT_PAGESIZE,
  TYPE_SEARCH,
  TYPE_SEARCH_PUBLIC_GROUP,
  TYPE_SEARCH_PUBLIC_PERSONAL,
  MAX_SEARCH,
} from './constants.js';
import { useUser, withUser } from '../UserContext/UserProvider.js';

const TabContact = ({ type, searchKeyword, onAdd, onClickCell, onRowSelect, height, tableHeight }) => {
  const ALL = 'ALL';
  const user = useUser();
  const [t] = useTranslation('contacts');

  const FILTER_APPOINTER = [
    {
      id: 1,
      title: 'Appointer',
      name: t('contacts.common.button.selectedPerson'),
      pubType: 'PERSONAL',
    },
    {
      id: 2,
      title: 'Team',
      name: t('contacts.common.text.dept'),
      pubType: 'DEPARTMENT',
    },
    {
      id: 3,
      title: 'Division',
      name: t('contacts.common.text.division'),
      pubType: 'SUBORG',
    },
    {
      id: 4,
      title: 'Company',
      name: t('contacts.common.text.comp'),
      pubType: 'COMPANY',
    },
  ];

  const delegateInfo = window.opener?.delegateInfo;

  const cUserId = delegateInfo?.managerInfo?.manager?.id ? delegateInfo?.managerInfo?.manager?.id : user.USERID;
  const originUser = delegateInfo?.impersonated ? 'N' : 'Y';
  const LOGINID = delegateInfo?.managerInfo?.managerDetail?.loginId
    ? delegateInfo?.managerInfo?.managerDetail?.loginId
    : user.LOGINID;
  const [selectedGroup, setSelectedGroup] = useState('');
  const [message, setMessage] = useState('');

  const [selectedFilterTeam, setSelectedFilterTeam] = useState(FILTER_TEAM[0]);
  const [selectedFilterMyContact, setselectedFilterMyContact] = useState(FILTER_TYPE[0]);
  const [selectedFilterGroup, setSelectedFilterGroup] = useState(FILTER_GROUP[0]);
  const [selectedFilterAppointer, setSelectedFilterAppointer] = useState(FILTER_APPOINTER[0]);

  const [isKnox, setIsKnox] = useState(true);
  const [isShowFilterMyContact, setIsShowFilterMyContact] = useState(true);
  const [isShowFilterGroup, setIsShowFilterGroup] = useState(false);
  const [isShowFilterAppointer, setIsShowFilterAppointer] = useState(false);

  const [groupList, setGroupList] = useState([]);
  const [contactList, setContactList] = useState([]);
  const [checkedList, setCheckedList] = useState([]);
  const [pageSize, setPageSize] = useState(20);
  const [totalElements, setTotalElements] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [fieldSearch, setFieldSearch] = useState();

  const [isMember, setIsMember] = useState(false);
  const [pubType, setPubType] = useState('');
  const [pubContacts, setPubContacts] = useState([]);
  const [filterPageSize, setFilterPageSize] = useState(DEFAULT_PAGESIZE[0]);

  useEffect(() => {
    (async () => {
      try {
        const { pubContactMenu } = await fetchPubContactMenu();
        const titles = new Set(pubContactMenu.map(item => item.title));
        const filteredAppointer = FILTER_APPOINTER.filter(item => titles.has(item.title));
        setPubContacts(filteredAppointer);
      } catch (e) {
        console.log(e);
      }
    })();
  }, []);

  const [isShowSelectedContact, setIsShowSelectedContact] = useState(false);
  const [selectedContactTable, setSelectedContactTable] = useState([]);

  const [controlOpenLayer, setControlOpenLayer] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [defaultKeyword, setDefaultKeyword] =
    searchKeyword && /^[$]/g.test(searchKeyword) ? useState(searchKeyword.substring(1)) : useState('');
  const [keyword, setKeyword] =
    searchKeyword && /^[$]/g.test(searchKeyword) ? useState(searchKeyword.substring(1)) : useState('');
  const [searchedKeyword, setSearchedKeyword] = useState('');
  const [hightLight, setHighLight] = useState('');
  const [title, setTitle] = useState('');

  const [isShowTable, setIsShowTable] = useState(true);
  const [groupSearchList, setGroupSearchList] = useState([]);

  const [groupResults, setGroupResults] = useState([]);
  const [selectedContactUID, setSelectedContactUID] = useState('');
  const [refetchContact, setRefetchContact] = useState(false);

  const keywordRef = useRef(keyword);
  const searchedKeywordRef = useRef(searchedKeyword);
  useEffect(() => {
    keywordRef.current = keyword;
  }, [keyword]);
  useEffect(() => {
    searchedKeywordRef.current = searchedKeyword;
  }, [searchedKeyword]);

  const tableRef = useRef(null);

  const [isShowProfile, setIsShowProfile] = useState(false);
  const [isShowGroup, setIsShowGroup] = useState(false);

  const [selectedDetailGroup, setSelectedDetailGroup] = useState('');
  const [sortType, setSortType] = useState({
    value: '',
    valueSet: false,
  });
  const [pageTemp, setPageTemp] = useState(0);

  const paginationRef = useRef(null);
  const tableWrapperRef = useRef(null);
  const toolbarRef = useRef(null);
  const optionRef = useRef(null);
  const layerRef = useRef(null);
  const resizeContentRef = useRef();
  const searchRef = useRef(null);

  // const getHeight = () => {
  //   const paginateHeight = paginationRef?.current?.getBoundingClientRect().height || 0;
  //   const optionRefHeight = optionRef?.current?.getBoundingClientRect().height || 0;
  //   const toolbarHeight = toolbarRef?.current?.getBoundingClientRect().height || 0;
  //   return `${height - toolbarHeight - optionRefHeight - 2 * paginateHeight}px`;
  // };

  const handleResetSelect = () => {
    setSelectedContactTable([]);
    setCheckedList(new Array(checkedList.length).fill(false));
  };

  const setProfilePopup = id => {
    setSelectedContactUID(id);
    setIsShowProfile(!!id);
  };

  const handleFilterKnox = value => {
    setSelectedFilterTeam(value);
    if (value.id === 2) {
      // set Team
      setIsMember(true);
      setIsKnox(false);
      setIsShowFilterMyContact(false);
    } else {
      // set Knox
      setIsKnox(true);
      setIsMember(false);
      setPubType('');
      setSelectedGroup('');
      setIsShowFilterMyContact(true);
      setselectedFilterMyContact(FILTER_TYPE[0]);
      setSelectedFilterGroup(FILTER_GROUP[0]);
      setSelectedFilterAppointer(FILTER_APPOINTER[0]);
    }
    setIsShowTable(true);
    setIsShowFilterGroup(false);
    setIsShowFilterAppointer(false);
    setPageNumber(0);
    setKeyword('');
    setSearchedKeyword('');
    setDefaultKeyword('');
    setHighLight('');
  };

  const handleFilterMyContact = value => {
    setIsShowTable(true);
    if (value.id === 2) {
      setIsShowFilterGroup(true);
      setIsShowFilterAppointer(true);
      setIsMember(true);
      if (pubType.length === 0) {
        setPubType('PERSONAL');
        setSelectedFilterAppointer(FILTER_APPOINTER[0]);
      }
      setSelectedFilterGroup(FILTER_GROUP[0]);
    } else {
      setGroupSearchList([]);
      setIsMember(false);
      setPubType('');
      setIsShowFilterGroup(false);
      setIsShowFilterAppointer(false);
    }
    setSelectedGroup('');
    setselectedFilterMyContact(value);
    setPageNumber(0);
    setTitle('');
    setKeyword('');
    setSearchedKeyword('');
    setDefaultKeyword('');
    setHighLight('');
  };

  const clearSortData = () => {
    setSortType({ value: '', valueSet: false });
  };

  // Mode Knox
  const getGroupKnox = async () => {
    try {
      const data = await getGroupList(0, 1000, pubType, originUser, cUserId);
      if (data?.elements?.length) {
        setGroupList(data.elements);
        if (pubType !== '') {
          setSelectedGroup(data.elements[0].uid);
        }
      } else {
        setGroupList([]);
        setContactList([]);
        setTotalElements(0);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handleFilterGroup = value => {
    setIsShowTable(true);
    setGroupSearchList([]);
    if (value.id === 1) {
      getGroupKnox();
      setIsMember(true);
    } else {
      setGroupList([]);
      setIsMember(false);
    }
    setSelectedFilterGroup(value);
    setPageNumber(0);
    setTitle('');
    setKeyword('');
    setSearchedKeyword('');
    setDefaultKeyword('');
    setHighLight('');
  };

  const handleFilterAppointer = value => {
    if (value.id === selectedFilterAppointer.id) return;
    setIsShowTable(true);
    setGroupSearchList([]);
    setPubType(value.pubType);
    setSelectedFilterAppointer(value);
    setSelectedGroup('');
    setPageNumber(0);
    setTitle('');
    setKeyword('');
    setSearchedKeyword('');
    setDefaultKeyword('');
    setHighLight('');
    setContactList([]);
  };

  // Mode Member
  const getContactMember = async (groupID, page = pageNumber) => {
    try {
      const sortProp = { orderField: '', orderType: '' };

      if (sortType.value) {
        sortProp.orderField = 'memberName';
        sortProp.orderType = sortType.value;
      } else if (selectedFilterMyContact === FILTER_TYPE[1]) {
        sortProp.orderField = 'sequence';
        sortProp.orderType = 'ASC';
      }
      const data = await getMemberGroup(
        groupID,
        page,
        pageSize,
        pubType,
        originUser,
        cUserId,
        sortProp.orderType,
        sortProp.orderField,
      );
      if (data && data.elements && data.elements.length > 0) {
        setContactList(data.elements);
        setPageNumber(data.pageNumber);
        setPageSize(data.pageSize);
        setTotalElements(data.totalElements);
        // setCheckedList(new Array(data.elements.length).fill(false));
      } else {
        setContactList([]);
        setPageNumber(0);
        setTotalElements(0);
        // setCheckedList([]);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handleSetTitleSearch = total => {
    if (!isMember || pubType === '') {
      setTitle(t('contacts.common.text.titleSearchResult', { 0: total }));
    }
    if (isMember && pubType !== '') {
      setTitle(t('contacts.common.text.titleSearchGroupResult', { 0: total }));
    }
  };

  const searchContactGroup = async (field, page = pageNumber, kw) => {
    const searchKw = kw !== undefined ? kw : searchedKeywordRef.current || keyword;
    try {
      const data = await searchContactGroupAPI(field, searchKw, page, pageSize, pubType, originUser, cUserId);
      if (data && data.elements && data.elements.length > 0) {
        setGroupSearchList(data.elements);
      } else {
        setGroupSearchList([]);
        setContactList([]);
      }
      setPageNumber(data?.pageNumber - 1 || 0);
      setPageSize(data?.pageSize || pageSize);
      setTotalElements(data?.totalElements || 0);
      handleSetTitleSearch(data?.totalElements || 0);
    } catch (e) {
      console.log(e);
    }
  };

  const searchContactCardPublic = async (field, page = pageNumber, kw) => {
    const searchKw = kw !== undefined ? kw : searchedKeywordRef.current || keyword;
    try {
      const data = await searchContactCardPublicAPI(field, searchKw, page, pageSize, pubType, originUser, cUserId);
      if (data && data.elements && data.elements.length > 0) {
        setContactList(data.elements);
      } else {
        setContactList([]);
      }
      setPageNumber(data?.pageNumber - 1 || 0);
      setPageSize(data?.pageSize || pageSize);
      setTotalElements(data?.totalElements || 0);
      handleSetTitleSearch(data?.totalElements || 0);
    } catch (e) {
      console.log(e);
    }
  };

  const searchContactCard = async (field, page = pageNumber, kw) => {
    const searchKw = kw !== undefined ? kw : searchedKeywordRef.current || keyword;
    try {
      const data = await searchContactCardAPI(
        selectedGroup,
        field,
        searchKw,
        page,
        pageSize,
        pubType,
        originUser,
        cUserId,
      );
      if (data && data.elements && data.elements.length > 0) {
        setContactList(data.elements);
      } else {
        setContactList([]);
      }
      setPageNumber(data?.pageNumber - 1 || 0);
      setPageSize(data?.pageSize || pageSize);
      setTotalElements(data?.totalElements || 0);
      handleSetTitleSearch(data?.totalElements || 0);
    } catch (e) {
      console.log(e);
    }
  };
  const handleSearchGroupName = groupName => {
    const result = groupList.filter(value => value.subject === groupName);
    if (result && result.length > 0) {
      const isDuplicate = result[0].uid === selectedGroup;
      setSelectedGroup(result[0].uid);
      isDuplicate && setRefetchContact(!refetchContact);
      setIsMember(true);
      setKeyword('');
      setSearchedKeyword('');
    } else {
      setMessage(t('contacts.common.message.notMatchSearchWord'));
    }
    setIsOpen(false);
    setControlOpenLayer(false);
  };

  const checkIfAllSpecialSearch = (key = '') => {
    const comcomis = 44; // character ','
    const space = 32;
    return key
      .trim()
      .toLowerCase()
      .split('')
      .filter(st => st.charCodeAt() !== space)
      .every(st => st.charCodeAt() === comcomis);
  };

  const handleSearch = (page = pageNumber, searchKeyword) => {
    const kw = searchKeyword !== undefined ? searchKeyword : keyword;
    if (checkIfAllSpecialSearch(kw.trim())) {
      setMessage(t('contact.text.search.noticeEnterKey'));
      return;
    }

    setMessage('');
    setIsOpen(false);
    setControlOpenLayer(false);
    setSelectedContactTable([]);
    if (isMember && pubType !== '' && kw) {
      searchedKeywordRef.current = kw;
      setSearchedKeyword(kw);
      setHighLight(kw);
      setIsShowTable(false);
      searchContactGroup(fieldSearch, page, kw);
      return;
    }
    if (!isMember && pubType !== '' && kw) {
      searchedKeywordRef.current = kw;
      setSearchedKeyword(kw);
      setHighLight(kw);
      searchContactCardPublic(fieldSearch, page, kw);
      return;
    }
    if (kw && fieldSearch !== 'GROUPNAME') {
      searchedKeywordRef.current = kw;
      setSearchedKeyword(kw);
      setHighLight(kw);
      searchContactCard(fieldSearch, page, kw);
    } else if (kw && fieldSearch === 'GROUPNAME') {
      handleSearchGroupName(kw);
    } else {
      setMessage(t('contacts.searchPeopleContactsTab.message.inputKeyword'));
    }
  };

  const handleCopySelect = () => {
    if (selectedContactTable.length > 0) {
      onAdd(selectedContactTable);
    }
  };

  const fetchAllContactTeam = async (loginId, group, originUser, cUserId) => {
    let page = 0;
    const allElements = [];
    while (true) {
      const pageData = await getContactTeamAPI(loginId, group, page, 100, originUser, cUserId);
      if (!pageData || !pageData.elements || pageData.elements.length === 0) break;
      allElements.push(...pageData.elements);
      if (pageData.elements.length < 100) break;
      page++;
    }

    return Object.defineProperty({}, 'elements', {
      value: allElements,
      writable: false,
    });
  };

  const handleCopyAll = async () => {
    let data;
    const sortProp = { orderField: '', orderType: '' };

    if (sortType.value) {
      sortProp.orderField = 'memberName';
      sortProp.orderType = sortType.value;
    } else if (selectedFilterMyContact === FILTER_TYPE[1]) {
      sortProp.orderField = 'sequence';
      sortProp.orderType = 'ASC';
    }
    if (keyword) {
      // if search
      if (isMember && pubType !== '') {
        data = await getMemberGroup(
          selectedDetailGroup,
          0,
          999999,
          pubType,
          originUser,
          cUserId,
          sortProp.orderType,
          sortProp.orderField,
        );
      } else if (!isMember && pubType !== '') {
        data = await searchContactCardPublicAPI(fieldSearch, keyword, 0, 999999, pubType, originUser, cUserId);
      } else {
        data = await searchContactCardAPI(selectedGroup, fieldSearch, keyword, 0, 999999, pubType);
      }
    } else if (isMember && selectedGroup) {
      if (totalElements > contactList.length) {
        if (selectedFilterTeam.id === 2) {
          // messenger contacts
          data = await fetchAllContactTeam(LOGINID, selectedGroup, originUser, cUserId);
        } else {
          data = await getMemberGroup(
            selectedGroup,
            0,
            999999,
            pubType,
            originUser,
            cUserId,
            sortProp.orderType,
            sortProp.orderField,
          );
        }
      } else {
        data = Object.defineProperty({}, 'elements', {
          value: contactList,
          writable: false,
        });
      }
    } else if (selectedFilterTeam.id === 2 && selectedGroup.length === 0) {
      // is messenger contact + empty group
      data = [];
    } else {
      data = await getContactList(0, 999999, pubType, originUser, cUserId, sortProp.orderType, sortProp.orderField);
    }
    if (data && data.elements && data.elements.length > 0) {
      onAdd(data.elements);
    }
  };

  const filterPaginate = (
    <DropdownList
      componentType="text"
      label={t('contacts.common.text.viewPage', { 0: filterPageSize })}
      value={filterPageSize}
      placement="bottom-left"
    >
      {DEFAULT_PAGESIZE.map(value => {
        return (
          <DropdownItem
            name={t('contacts.common.text.viewPage', { 0: value })}
            onClick={() => {
              setPageSize(value);
              setFilterPageSize(value);
            }}
            value={value}
          />
        );
      })}
    </DropdownList>
  );

  const handleShowDetailSearchGroup = uid => {
    setPageNumber(0);
    getContactMember(uid, 0);
    setIsShowTable(true);
    setTitle('');
    setSelectedDetailGroup(uid);
  };

  const groupSearchResult = (
    <>
      {isShowTable && selectedDetailGroup && (
        <div className={classes.backPrevious}>
          <Button
            componentType="link"
            className="text-primary"
            label={t('contacts.searchPeopleContactsTab.text.gotoPrev')}
            onClick={() => {
              setIsShowTable(false);
              setPageNumber(pageTemp);
              handleSearch(pageTemp);
            }}
          />
        </div>
      )}
      {!isShowTable && (
        <>
          {groupSearchList.length > 0 ? (
            <div className="grid-table-wrap">
              <div className="grid-table-body  scroll-show" style={{ height: tableHeight, maxHeight: tableHeight }}>
                <div
                  style={{
                    height: '100%',
                    width: '100%',
                    maxWidth: 'inherit',
                    maxHeight: 'inherit',
                    overflowY: 'auto',
                  }}
                >
                  <div className="grid-table ">
                    <table>
                      <colgroup>
                        <col style={{ width: '90%' }} />

                        <col style={{ width: '10%' }} />
                      </colgroup>
                      <tbody>
                        {groupSearchList.map((value, index) => {
                          return (
                            <tr key={`group-result-${value.uid}`}>
                              <td>
                                <div className="grid-data-cell">
                                  <Button
                                    componentType="normal"
                                    className="normal"
                                    onClick={() => {
                                      (async () => {
                                        try {
                                          const data = await getContactAPI(value.uid);
                                          if (data && data.contacts && data.contacts.length > 0) {
                                            onAdd(data.contacts);
                                          }
                                        } catch (e) {
                                          console.log(e);
                                        }
                                      })();
                                    }}
                                  >
                                    <WordHighLighter
                                      text={value.subject}
                                      highlightText={keyword}
                                      styles={{ maxWidth: '500px', overflow: 'hidden', textOverflow: 'ellipsis' }}
                                    />
                                  </Button>
                                </div>
                              </td>
                              <td>
                                <div className="grid-data-cell">
                                  <Button
                                    componentType="normal"
                                    className="normal "
                                    style={{ marginLeft: 'auto' }}
                                    label={t('contacts.common.button.detailInput')}
                                    onClick={() => handleShowDetailSearchGroup(value.uid)}
                                  />
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="empty-area">
              <p className={classes.noData}>{t('contacts.manageGroup.message.noMember')}</p>
            </div>
          )}
        </>
      )}
    </>
  );

  const toolbarTable = (
    <>
      {title && searchedKeyword && (
        <div className="grid-table-option option-title" ref={toolbarRef}>
          <div className="option-group">
            <h2 className="title">
              <span className="text">{title}</span>
            </h2>
          </div>
        </div>
      )}
      {groupSearchList && groupSearchResult}
      {isShowTable && (
        <div className="grid-table-option" ref={optionRef}>
          <div className="option-group">
            {!isShowSelectedContact && (
              <div className="counter">
                <span className="text">{t('contacts.common.text.total')}</span>
                <span className="num">{totalElements}</span>
              </div>
            )}
            {isShowSelectedContact && (
              <div className="counter">
                <span className="text">{t('contacts.common.text.selection')}</span>
                <span className="num">{selectedContactTable && selectedContactTable.length}</span>
              </div>
            )}
            {isShowSelectedContact && (
              <button
                type="button"
                className="pt-btn sm text-primary"
                onClick={() => {
                  handleResetSelect();
                }}
              >
                <i className="ic-refresh sm active" />
                <span className="text">{t('contacts.common.button.removeSelection')}</span>
              </button>
            )}
            {isShowSelectedContact && (
              <button
                type="button"
                className="pt-btn sm line"
                onClick={() => {
                  handleCopySelect();
                }}
              >
                <span className="text">{t('contacts.searchConferenceRoom.button.addSelected')}</span>
              </button>
            )}
            {!isShowSelectedContact && filterPaginate}
          </div>
          <div className="option-group">
            {!isShowSelectedContact && type !== 'VIEW' && (
              <Button
                className="line"
                size="sm"
                label={t('contacts.searchPeopleContactsTab.text.appendAll')}
                onClick={() => handleCopyAll()}
              />
            )}
          </div>
        </div>
      )}
    </>
  );

  const hightLightSearch = () => {
    return (
      <div className="search-lately">
        {t('contacts.common.text.titleSearch')} &nbsp;
        <WordHighLighter highlightText={`'${keyword}'`} text={`'${keyword}'`} styles="mark" />
      </div>
    );
  };

  const layer = (
    <>
      <div className="dropdown-list bottom-right  active dropdown-wrap auto-complete" ref={layerRef}>
        <div
          className="container popup-search-wrap custom-search"
          onClick={() => {
            if (checkIfAllSpecialSearch(keywordRef.current.trim())) {
              setMessage(t('contact.text.search.noticeEnterKey'));
              return;
            }
            if (pageNumber > 0) {
              setPageNumber(0);
              setFieldSearch(ALL);
              handleSearch(0, keywordRef.current);
            } else if (fieldSearch === ALL) {
              handleSearch(undefined, keywordRef.current);
            } else {
              setFieldSearch(ALL);
              setPageNumber(0);
            }
          }}
        >
          {hightLightSearch()}
        </div>
        <ul>
          {pubType === '' &&
            TYPE_SEARCH.map((value, index) => {
              return (
                <li
                  className="dropdown-item selected1"
                  key={index}
                  onClick={() => {
                    if (pageNumber > 0) {
                      setPageNumber(0);
                      setFieldSearch(value.type);
                    } else if (fieldSearch === value.type) {
                      handleSearch();
                    } else {
                      setFieldSearch(value.type);
                      setPageNumber(0);
                    }
                  }}
                >
                  <a
                    className="link"
                    onMouseEnter={() => {
                      if (value.type === 'GROUPNAME') {
                        setIsShowGroup(true);
                      }
                    }}
                  >
                    - {value.name}:&nbsp; <WordHighLighter highlightText={keyword} text={keyword} styles="mark" />
                    {value.type === 'GROUPNAME' && <i className="ic-right xs" />}
                  </a>
                </li>
              );
            })}
          {pubType !== '' &&
            isMember &&
            TYPE_SEARCH_PUBLIC_GROUP.map((value, index) => {
              return (
                <li
                  className="dropdown-item selected1"
                  key={index}
                  onClick={() => {
                    if (pageNumber > 0) {
                      setPageNumber(0);
                      setFieldSearch(value.type);
                    } else if (fieldSearch === value.type) {
                      handleSearch();
                    } else {
                      setPageNumber(0);
                      setFieldSearch(value.type);
                    }
                  }}
                >
                  <a className="link">
                    - {value.name}:&nbsp; <WordHighLighter highlightText={keyword} text={keyword} styles="mark" />
                  </a>
                </li>
              );
            })}
          {pubType !== '' &&
            !isMember &&
            TYPE_SEARCH_PUBLIC_PERSONAL.map((value, index) => {
              return (
                <li
                  className="dropdown-item selected1"
                  key={index}
                  onClick={() => {
                    if (pageNumber > 0) {
                      setPageNumber(0);
                      setFieldSearch(value.type);
                    } else if (fieldSearch === value.type) {
                      handleSearch();
                    } else {
                      setPageNumber(0);
                      setFieldSearch(value.type);
                    }
                  }}
                >
                  <a className="link">
                    - {value.name}:&nbsp; <WordHighLighter highlightText={keyword} text={keyword} styles="mark" />
                  </a>
                </li>
              );
            })}
        </ul>
      </div>
      {isShowGroup && (
        <div
          className="dropdown-list depth-2 active"
          style={{
            right: layerRef?.current?.getBoundingClientRect().width,
            top: layerRef?.current?.getBoundingClientRect().height - 40,
          }}
          onMouseLeave={() => {
            setIsShowGroup(false);
          }}
        >
          <ul className="active" style={{ maxHeight: '200px' }}>
            {groupResults?.length > 0 && (
              <div
                style={{ height: '100%', width: '100%', maxWidth: 'inherit', maxHeight: 'inherit', overflowY: 'auto' }}
              >
                {groupResults.map((result, key) => {
                  return (
                    <li
                      className="dropdown-item"
                      key={key}
                      onClick={() => {
                        handleSearchGroupName(result.subject);
                      }}
                    >
                      <WordHighLighter text={result.subject} highlightText={keyword} styles="mark" />
                    </li>
                  );
                })}
              </div>
            )}
            {groupResults?.length === 0 && (
              <li className="dropdown-item">{t('contacts.common.message.noSearchResult')}</li>
            )}
          </ul>
        </div>
      )}
    </>
  );

  const search = (
    <Tooltip componentType="move" label={t('contacts.text.search.placeholer')}>
      <SearchBox
        componentType="single"
        left="bottom-left"
        ref={searchRef}
        layerComponent={layer}
        placeholder={t('contacts.text.search.placeholer')}
        value={keyword}
        onSearch={e => {
          const txt = e ? e.trim() : '';
          if (checkIfAllSpecialSearch(txt)) {
            setMessage(t('contact.text.search.noticeEnterKey'));
            searchRef.current?.blur();
            return;
          }
          if (pageNumber > 0) {
            setPageNumber(0);
            setFieldSearch(ALL);
            handleSearch(0, txt);
          } else if (fieldSearch === ALL) {
            handleSearch(undefined, txt);
          } else {
            setPageNumber(0);
            setFieldSearch(ALL);
          }
          searchRef.current?.blur();
        }}
        onChange={e => {
          const value = e.target.value.trim();
          if (value.length > MAX_SEARCH) {
            setMessage(t('contacts.common.message.maxOverInputByte'));
            return;
          }
          const truncated = value.substring(0, MAX_SEARCH);
          setKeyword(truncated);
          keywordRef.current = truncated;
          const isShowLayer = value.trim().length > 0 && document.activeElement === searchRef.current;
          setControlOpenLayer(isShowLayer);
          setIsOpen(isShowLayer);
        }}
        onKeyUp={e => {}}
        onClick={e => {
          if (e.target.value.length > 0) {
            setControlOpenLayer(true);
            setIsOpen(true);
          } else {
            setControlOpenLayer(false);
          }
        }}
        isShowLayer={isOpen}
        controlOpenLayer={controlOpenLayer}
        onCloseLayer={() => setIsShowGroup(false)}
      />
    </Tooltip>
  );

  const filterTeam = (
    <DropdownList
      componentType="text"
      value={selectedFilterTeam.id}
      label={selectedFilterTeam.name}
      placement="bottom-left"
    >
      {FILTER_TEAM.map(value => {
        return (
          <DropdownItem
            key={value.id}
            name={value.name}
            value={value.id}
            onClick={() => {
              clearSortData();
              setGroupSearchList([]);
              handleFilterKnox(value);
              setSelectedContactTable([]);
              setSelectedDetailGroup('');
              setTitle('');
            }}
          />
        );
      })}
    </DropdownList>
  );

  const filterMyContact = (
    <DropdownList
      componentType="text"
      value={selectedFilterMyContact.id}
      label={selectedFilterMyContact.name}
      placement="bottom-left"
    >
      {FILTER_TYPE.map(value => {
        return (
          <DropdownItem
            name={value.name}
            onClick={() => {
              clearSortData();
              handleFilterMyContact(value);
              setSelectedDetailGroup('');
              setSelectedContactTable([]);
            }}
            value={value.id}
          />
        );
      })}
    </DropdownList>
  );

  const filterGroup = (
    <DropdownList
      componentType="text"
      value={selectedFilterGroup.id}
      label={selectedFilterGroup.name}
      placement="bottom-left"
    >
      {FILTER_GROUP.map(value => {
        return (
          <DropdownItem
            name={value.name}
            onClick={() => {
              clearSortData();
              handleFilterGroup(value);
              setSelectedDetailGroup('');
              setSelectedContactTable([]);
            }}
            value={value.id}
          />
        );
      })}
    </DropdownList>
  );

  const filterAppointer = (
    <DropdownList
      componentType="text"
      value={selectedFilterAppointer.id}
      label={selectedFilterAppointer.name}
      placement="bottom-left"
    >
      {pubContacts.map(value => {
        return (
          <DropdownItem
            name={value.name}
            onClick={() => {
              clearSortData();
              handleFilterAppointer(value);
              setSelectedDetailGroup('');
              setSelectedContactTable([]);
            }}
            value={value.id}
          />
        );
      })}
    </DropdownList>
  );

  // get info user loggin
  // const getUserInfo = async () => {
  //   try {
  //     const data = await getUserInfoAPI();
  //     if (data) {
  //       // const knoxID = data.USERDN.split(',')[0].split('=')[1]; // get KNOX ID
  //       setUser(data);
  //     }
  //   } catch (e) {
  //     console.log(e);
  //   }
  // };

  // Mode Team
  const getGroupTeam = async () => {
    try {
      const data = await getGroupTeamAPI(LOGINID, originUser, cUserId);
      if (data && data.length > 0) {
        setGroupList(data);
        setSelectedGroup(data[0].uid);
      } else {
        setGroupList([]);
      }
      setIsMember(true);
    } catch (e) {
      console.log(e);
    }
  };

  // handle get groups following mode
  const getGroups = () => {
    if (isKnox && (isMember || (!isMember && !pubType))) {
      getGroupKnox();
      return;
    }
    if (!isKnox) {
      getGroupTeam();
    }
  };

  // Mode Team
  const getContactTeam = async (page = pageNumber) => {
    try {
      const data = await getContactTeamAPI(LOGINID, selectedGroup, page, pageSize, originUser, cUserId);
      if (data && data.elements && data.elements.length > 0) {
        setContactList(data.elements);
        setPageNumber(data.pageNumber);
        setPageSize(data.pageSize);
        setTotalElements(data.totalElements);
        // setCheckedList(new Array(data.elements.length).fill(false));
      } else {
        setContactList([]);
        setPageNumber(0);
        setTotalElements(0);
        // setCheckedList([]);
      }
    } catch (e) {
      console.log(e);
    }
  };

  // Mode Personally
  const getContactCard = async (page = pageNumber) => {
    try {
      const orderField = pubType === 'PERSONAL' ? 'fullName' : 'memberName';
      const orderType = sortType.value.length === 0 ? 'ASC' : sortType.value;
      if (sortType.value.length === 0) {
        setSortType({
          value: orderType,
          valueSet: pageNumber === 0,
        });
      }
      const data = await getContactList(page, pageSize, pubType, originUser, cUserId, orderType, orderField);
      if (data && data.elements) {
        setContactList(data.elements);
        setPageNumber(data.pageNumber);
        setPageSize(data.pageSize);
        setTotalElements(data.totalElements);
        // setCheckedList(new Array(data.elements.length).fill(false));
      } else {
        setContactList([]);
        setPageNumber(0);
        setTotalElements(0);
        // setCheckedList([]);
      }
    } catch (e) {
      console.log(e);
    }
  };

  // handle get contacts following mode
  const getContacts = (page, currentKeyword) => {
    const effectiveKeyword = currentKeyword !== undefined ? currentKeyword : keyword;
    if (effectiveKeyword) {
      if (selectedDetailGroup.length > 0 && isShowTable) {
        getContactMember(selectedDetailGroup, page);
      } else {
        handleSearch(page, effectiveKeyword);
      }
      return;
    }
    if (!isKnox) {
      getContactTeam(page);
      return;
    }
    if (isKnox && isMember && selectedGroup) {
      getContactMember(selectedGroup, page);
      return;
    }
    if (!isMember) {
      getContactCard(page);
    }
  };

  const handleSearchGroup = async () => {
    try {
      if (keyword && keyword.length > 0 && pubType === '') {
        const data = await searchGroupAPI(keyword, originUser, cUserId);
        if (data && data.elements.length > 0) {
          setGroupResults(data.elements);
        } else {
          setGroupResults([]);
        }
        setIsShowGroup(false);
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    setIsShowSelectedContact(selectedContactTable && selectedContactTable.length > 0);
  }, [selectedContactTable]);

  useEffect(() => {
    if (!defaultKeyword && cUserId) {
      getGroups();
    }
  }, [isKnox, isMember, pubType, cUserId, originUser]);

  useEffect(() => {
    cUserId && getContacts();
  }, [selectedGroup, isKnox, isMember, pubType, fieldSearch, refetchContact, cUserId, originUser]);

  useEffect(() => {
    getContacts(0, searchedKeywordRef.current);
  }, [pageSize]);

  useEffect(() => {
    handleSearchGroup();
  }, [keyword]);

  useEffect(() => {
    if (sortType.valueSet) {
      getContacts();
      setSortType({
        ...sortType,
        valueSet: false,
      });
    }
  }, [sortType]);

  const handleClickSortIcon = () => {
    if (hightLight.length === 0 && contactList.length > 0) {
      setSortType({
        value: sortType.value === 'ASC' || sortType.value.length === 0 ? 'DESC' : 'ASC',
        valueSet: true,
      });
      tableRef.current?.setScrollUpTop();
      setSelectedContactTable([]);
      setPageNumber(0);
    }
  };

  const sortIcon = {
    ASC: 'ic-receive-up',
    DESC: 'ic-receive-down',
  };

  const headerItem = [
    {
      dataField: 'fullName',
      resizeable: false,
      width: '25%',
      hasTooltip: true,
      headerRenderer: () => {
        return (
          <>
            <Tooltip
              componentType="hover"
              label={t('contacts.common.text.nameInfoTable')}
              isShow
              placement="bottom-start"
            >
              <span className="text" onClick={handleClickSortIcon}>
                {t('contacts.common.text.nameInfoTable')}
              </span>
            </Tooltip>
            {hightLight.length === 0 && contactList.length > 0 && isShowFilterMyContact && (
              <Button
                componentType="noneBtn"
                className="btn-sort md"
                iconInfo={{
                  className: sortIcon[sortType.value] || sortIcon.ASC,
                  size: 'xs',
                }}
                onClick={handleClickSortIcon}
              />
            )}
          </>
        );
      },
      cellsRenderer: (row, column, dataField, rowData, searchText, style) => {
        const sourcedEmp = rowData.type && rowData.type === 'EMP';
        const targetId = sourcedEmp ? rowData.sourceId : rowData.uid;
        const isEmpRetire = rowData.empStatus === 'RETIRE';

        let text = <WordHighLighter text={rowData[dataField]} highlightText={searchText} />;
        if (
          fieldSearch !== ALL &&
          fieldSearch !== TYPE_SEARCH[0].type &&
          fieldSearch !== TYPE_SEARCH_PUBLIC_GROUP[1].type
        ) {
          text = (
            <span onClick={e => e.stopPropagation()} className="text " style={{ cursor: 'pointer' }}>
              {rowData[dataField]}
            </span>
          );
        }
        const avaLink =
          rowData.photo && rowData.photo.split('^')[2]
            ? `${rowData.photo.split('^')[2]}`
            : `/employee/empsearch/rest/v1/photo/tinythumb?epid=${targetId}`;
        const avatarProfile = (
          <img
            style={{
              width: '24px',
              height: '24px',
              minWidth: '24px',
              borderRadius: '50%',
              backgroundSize: '100%',
            }}
            src={avaLink}
            alt="img"
          />
        );

        if (rowData[dataField]) {
          return (
            <>
              {sourcedEmp && !isEmpRetire ? (
                <HoverCard zIndex={3000} epid={targetId} useProfileCard>
                  {avatarProfile}
                </HoverCard>
              ) : (
                <div>{avatarProfile}</div>
              )}
              <Tooltip componentType="hover" isShow label={rowData[dataField]}>
                <span className="text">{text}</span>
              </Tooltip>
            </>
          );
        }
        return <></>;
      },
    },
    {
      dataField: 'title',

      sortable: false,
      text: t('contacts.favoriteCalendar.text.fullname'),
      width: '15%',
      hasTooltip: true,
      cellsRenderer: (row, column, dataField, rowData, searchText, style) => {
        let text = <WordHighLighter text={rowData[dataField]} highlightText={searchText} />;
        if (fieldSearch !== ALL && fieldSearch !== TYPE_SEARCH[1].type) {
          text = <span className="text">{rowData[dataField]}</span>;
        }

        if (rowData[dataField] && rowData[dataField]) {
          return (
            <Tooltip componentType="hover" isShow label={rowData[dataField]}>
              <span className="text">{text}</span>
            </Tooltip>
          );
        }
        return <></>;
      },
    },
    {
      dataField: 'deptName',

      sortable: false,
      text: t('contacts.common.text.dept'),
      width: '15%',
      hasTooltip: true,
      cellsRenderer: (row, column, dataField, rowData, searchText, style) => {
        let text = <WordHighLighter text={rowData[dataField]} highlightText={searchText} />;
        if (fieldSearch !== ALL && fieldSearch !== TYPE_SEARCH[2].type) {
          text = <span className="text">{rowData[dataField]}</span>;
        }

        if (rowData[dataField]) {
          return (
            <Tooltip componentType="hover" isShow label={rowData[dataField]}>
              <span className="text">{text}</span>
            </Tooltip>
          );
        }
        return <></>;
      },
    },
    {
      dataField: 'compName',

      sortable: false,
      text: t('contacts.common.text.comp'),
      width: '15%',
      hasTooltip: true,
      cellsRenderer: (row, column, dataField, rowData, searchText, style) => {
        let text = <WordHighLighter text={rowData[dataField]} highlightText={searchText} />;
        if (fieldSearch !== ALL && fieldSearch !== TYPE_SEARCH[3].type) {
          text = <span className="text">{rowData[dataField]}</span>;
        }

        if (rowData[dataField]) {
          return (
            <Tooltip componentType="hover" isShow label={rowData[dataField]}>
              <span className="text">{text}</span>
            </Tooltip>
          );
        }
        return <></>;
      },
    },
    {
      dataField: 'emails',

      sortable: false,
      text: t('contacts.common.text.email'),
      width: '15%',
      hasTooltip: true,
      cellsRenderer: (row, column, dataField, rowData, searchText, style) => {
        let text =
          rowData[dataField] && rowData[dataField][0] && rowData[dataField][0].val ? (
            <WordHighLighter text={rowData[dataField][0].val} highlightText={searchText} />
          ) : (
            ''
          );
        if (
          fieldSearch !== ALL &&
          fieldSearch !== TYPE_SEARCH[5].type &&
          rowData[dataField] &&
          rowData[dataField][0] &&
          rowData[dataField][0].val
        ) {
          text = <span className="text">{rowData[dataField][0].val}</span>;
        }

        if (rowData[dataField] && rowData[dataField][0] && rowData[dataField][0].val) {
          return (
            <Tooltip componentType="hover" isShow label={rowData[dataField][0].val}>
              <span className="text">{text}</span>
            </Tooltip>
          );
        }
        return <></>;
      },
    },
    {
      dataField: 'empStatus',

      sortable: false,
      text: t('contacts.common.text.status'),
      width: '15%',
      hasTooltip: true,
      cellsRenderer: (row, column, dataField, rowData, searchText, style) => {
        if (rowData[dataField]) {
          switch (rowData[dataField]) {
            case 'REGULAR':
              return t('contacts.common.text.empRegular');
            case 'BREAK':
              return t('contacts.common.text.empBreak');
            case 'RETIRE':
              return t('contacts.common.text.empRetire');
            case 'MOVED':
              return t('contacts.common.text.empTransferred');
            default:
              return '';
          }
        }
        return <></>;
      },
    },
  ];

  if (type !== 'VIEW') {
    headerItem.unshift({
      columnCheckBox: true,
      resizeable: false,
      width: '32px',
      dataField: 'selected',
    });
  }

  const table = (
    <>
      {isShowTable && (
        <Table
          height={tableHeight}
          maxHeight={tableHeight}
          ref={tableRef}
          addItems={null}
          data={contactList}
          checkedList={checkedList}
          headers={headerItem}
          onClickCell={({ rowIndex, columnIndex, dataField, rowdata, dataSource, event }) => {
            onClickCell({ rowIndex, columnIndex, dataField, rowdata, dataSource, event });
            if (type === 'VIEW') {
              const sourcedEmp = rowdata.sourceId && rowdata.sourceId.startsWith('M');
              const targetId = sourcedEmp ? rowdata.sourceId : rowdata.uid;
              setSelectedContactUID(targetId);
              setIsShowProfile(true);
            }
            if (type === 'ADD' && columnIndex !== 0) {
              onAdd([rowdata]);
            }
          }}
          onRowSelect={({ isCheckAll, dataSource, checked, rowSelected, rowIndex }) => {
            onRowSelect({ isCheckAll, dataSource, checked, rowSelected, rowIndex });
            if (isCheckAll) {
              setSelectedContactTable(dataSource);
              return;
            }
            setSelectedContactTable([]);

            if (rowSelected) {
              setSelectedContactTable([...selectedContactTable, dataSource[rowIndex]]);
              return;
            }
            const index = selectedContactTable.indexOf(dataSource[rowIndex]);
            if (index !== -1) {
              const list = [...selectedContactTable];
              list.splice(index, 1);
              setSelectedContactTable(list);
            }
          }}
          pageSize={pageSize}
          searchText={hightLight}
          showToolbar={false}
          emptyComponent={
            <div className="empty-area">
              <p className={classes.noData}>{t('contacts.manageGroup.message.noMember')}</p>
            </div>
          }
        />
      )}
    </>
  );

  const pagination = (
    <>
      {contactList && contactList.length > 0 && (
        <Pagination
          key={totalElements}
          ref={paginationRef}
          defaultCurrentPage={pageNumber + 1}
          onChange={page => {
            tableRef.current?.setScrollUpTop();
            setMessage('');
            setSelectedContactTable([]);
            setPageNumber(page - 1);
            if (searchedKeywordRef.current) {
              getContacts(page - 1, searchedKeywordRef.current);
            } else {
              getContacts(page - 1, '');
            }
            if (!isShowTable) setPageTemp(page - 1);
          }}
          pageNumberShow={10}
          pageSize={pageSize}
          totalItems={totalElements}
        >
          Default
        </Pagination>
      )}{' '}
    </>
  );

  return (
    <>
      <div ref={tableWrapperRef} className="tabContact-container">
        <div className="grid-table-option option-search">
          <div className="option-group">
            {filterTeam}
            {isShowFilterMyContact && filterMyContact}
            {isShowFilterGroup && filterGroup}
            {isShowFilterAppointer && filterAppointer}
          </div>
          <div className="option-group">{isShowFilterMyContact && search}</div>
        </div>
        <div className="emp-user-contents" style={{ alignItems: 'unset' }}>
          <div className="emp-user-aside" style={{ alignSelf: 'start' }} ref={resizeContentRef}>
            <div className="aside-content  scroll-show" style={{ height: `${height}px` }}>
              <div
                id="ContactAsideScroll"
                style={{
                  height: '100%',
                  width: '100%',
                  maxWidth: 'inherit',
                  maxHeight: 'inherit',
                  overflowY: 'auto',
                  paddingBottom: '26px',
                }}
              >
                <ul className="btn-list">
                  {isKnox && pubType === '' && !searchKeyword && (
                    <li>
                      <button
                        type="button"
                        onClick={() => {
                          clearSortData();
                          setSelectedGroup('');
                          setSelectedContactTable([]);
                          setKeyword('');
                          setSearchedKeyword('');
                          setHighLight('');
                          setIsMember(false);
                          setRefetchContact(!refetchContact);
                        }}
                        className={selectedGroup === '' ? 'pt-btn md active' : 'pt-btn md'}
                      >
                        <Tooltip componentType="hover" isShow label={t('contacts.common.text.eachContacts')}>
                          <span
                            className="text"
                            style={{ overflow: 'hidden', textOverflow: 'ellipsis', textAlign: 'left' }}
                          >
                            {t('contacts.common.text.eachContacts')}
                          </span>
                        </Tooltip>
                      </button>
                    </li>
                  )}
                  {pubType !== '' && !isMember && (
                    <li>
                      <button type="button" className="pt-btn md active">
                        <Tooltip
                          componentType="hover"
                          isShow
                          label={t('contacts.searchPeopleContactsTab.text.byContactList')}
                        >
                          <span
                            className="text"
                            style={{ overflow: 'hidden', textOverflow: 'ellipsis', textAlign: 'left' }}
                          >
                            {t('contacts.searchPeopleContactsTab.text.byContactList')}
                          </span>
                        </Tooltip>
                      </button>
                    </li>
                  )}
                  {groupList.map((value, index) => {
                    const subject =
                      value.type === 'BASIC_GROUP' && value.subject === '기본 그룹'
                        ? t('contacts.common.text.defaultGroup')
                        : value.subject;
                    return (
                      <li key={index}>
                        <button
                          type="button"
                          className={value.uid === selectedGroup ? 'pt-btn md active' : 'pt-btn md'}
                          onClick={() => {
                            clearSortData();
                            setIsShowTable(true);
                            setGroupSearchList([]);
                            setKeyword('');
                            setSearchedKeyword('');
                            setDefaultKeyword('');
                            setSelectedGroup(value.uid);
                            setSelectedContactTable([]);
                            setSelectedDetailGroup('');
                            setTitle('');
                            setHighLight('');
                            setRefetchContact(!refetchContact);
                            if (!pubType) {
                              setIsMember(true);
                            }
                            setPageNumber(0);
                            selectedFilterTeam.id === 1 && createRecentContact(value.uid);
                          }}
                        >
                          <Tooltip componentType="hover" isShow label={subject}>
                            <span
                              className="text"
                              style={{ overflow: 'hidden', textOverflow: 'ellipsis', textAlign: 'left' }}
                            >
                              {subject}
                            </span>
                          </Tooltip>
                        </button>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
            <Divider placement="right" ref={resizeContentRef} />
          </div>

          <div className="emp-user-list tabContact-list">
            {toolbarTable}
            {table}
            {pagination}
          </div>
        </div>
      </div>
      {isShowProfile &&
        (selectedContactUID.indexOf('CT') !== -1 ? (
          <ContactProfileCard
            uid={selectedContactUID}
            groupID={selectedGroup}
            originUser={originUser}
            cUserId={cUserId}
            closeFunction={() => setProfilePopup('')}
            user={user}
          />
        ) : (
          <ProfileCard
            cardType="employee"
            epid={selectedContactUID}
            isShow={isShowProfile}
            setIsShow={() => setProfilePopup('')}
          />
        ))}

      {message.length > 0 && (
        <Popup
          isDimed
          zIndex={2010}
          closeFunction={() => setMessage('')}
          size="xs"
          buttonComponent={[
            <div className="btn-set al-right">
              <Button
                componentType="solid"
                className="primary"
                onClick={() => setMessage('')}
                label={t('contacts.searchPeopleContactsTab.text.ok')}
              />
            </div>,
          ]}
          theme={user.DARKMODEYN === 'Y' ? 'dark' : 'light'}
          componentType="messagePopup"
          messageComponent={[<p>{message}</p>]}
          titleComponent={[<h1 className="popup-title">{t('contacts.common.text.notice')}</h1>]}
        />
      )}
    </>
  );
};

TabContact.propTypes = {
  type: PropTypes.string,
  searchKeyword: PropTypes.string,
  onAdd: PropTypes.func,
  onClickCell: PropTypes.func,
  onRowSelect: PropTypes.func,
  height: PropTypes.number,
  tableHeight: PropTypes.string,
};

TabContact.defaultProps = {
  type: '',
  searchKeyword: '',
  onAdd: () => {},
  onClickCell: () => {},
  onRowSelect: () => {},
  height: 500,
  tableHeight: '410px',
};

export default withUser(TabContact);
